<template>
  <div>
    <template v-if="objectType === 'Form'">
      <search-forms
        v-if="searchType === 'analystDashboardForms'"
        v-model="selectedInstanceObject"
        @input="instanceObjectSelected"
        :organization-id="organization.id"
        :disabled="!isEditing"
        analyst-dashboard-endpoint
      />
    </template>

    <template v-if="objectType === 'Portal'">
      <a-select
        v-model="selectedInstanceObject"
        bind-by-object
        :options="portalSelectOptions"
        @input="instanceObjectSelected"
        :disabled="!isEditing"
      />
    </template>

    <template v-if="objectType === 'Folder'">

      <button v-if="isEditing" class="btn blue" @click="showHideModal('folderLookup', true)">
        {{ selectedInstanceObject ? selectedInstanceObject.name : 'Select Folder' }}
      </button>
      <button v-else>
        {{selectedInstanceObject.name}}
      </button>

      <div class="context-menu">
        <folder-move-to-contents
          v-if="modalState.folderLookup === true"
          :folder="folder"
          :options="folderLookupOptions"
          @close="showHideModal('folderLookup', false)"
          @selected="selectFolderFromLookup"
        ></folder-move-to-contents>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import * as _ from 'lodash';
  import Selected from "../../store/modules/selected";
  import Organization from "../../../../common/models/organization";
  import SearchForms from "../../../../common/components/searchAndSelect/searchForms.vue"
  import {IVOptionSetLocal} from "../../../../common/interfaces/vSelectInterfaces";
  import Folder from "../../../document_management/models/folder";
  import FolderMoveToContents from "../../../document_management/components/folderMoveToContents.vue";

  export default Vue.extend({
    components: {SearchForms, FolderMoveToContents},
    props: {
      builderConfig: {
        type: Object,
        required: true,
      },
      level: {
        type: Number,
        required: true,
      },
      isEditing: {
        type: Boolean,
        required: true,
      },
    },
    data: function(): object {
      return {
        modalState: {
          folderLookup: {
            type: Boolean,
            default: false
          },
        },
      };
    },
    computed: {
      selectedInstanceObject: {
        get(): any {
          return this.$store.state.bookmarkLinkBuilderInterfaceStore.selectedInstanceObject;
        },
        set(value: any) {
          this.$store.commit('bookmarkLinkBuilderInterfaceStore/setSelectedInstanceObject', value);
          this.$store.commit('bookmarkLinkBuilderInterfaceStore/setSelectedInstanceObjectType', this.objectType);
        }
      },
      organization(): Organization {
        return Selected.organization.get();
      },
      portalSelectOptions(): IVOptionSetLocal {
        const portals = this.$store.state.bookmarkLinkBuilderInterfaceStore.portalsForDropdownSelect;
        let selectedOption = null;

        const stateSelectedObject = this.selectedInstanceObject;
        if (stateSelectedObject) {
          selectedOption = _.find(portals, function (option) {return option.id === stateSelectedObject.id});
        }

        return {
          options: portals,
          labelKey: "title",
          valueKey: "id",
          selectedOption,
        };
      },
      objectType() {
        return this.builderConfig.children[0].instanceObjectSelect;
      },
      searchType() {
        return this.builderConfig.children[0].searchType;
      },
      folder(): Folder {
        return this.$store.state.folderLookupStore.organization.folders[0];
      },
      folderLookupOptions() {
        return {
          store: 'folderLookupStore',
          selectOnly: true,
        }
      },
    },
    methods: {
      instanceObjectSelected(obj) {
        if (obj) {
          const childConfig = this.builderConfig.children[0];
          this.$store.commit('bookmarkLinkBuilderInterfaceStore/setSelectedConfig', {config: childConfig, level: (this.level + 1)});
        }
      },
      showHideModal(modal: 'folderLookup', show: boolean): void {
        this.modalState[modal] = show
      },
      selectFolderFromLookup(folder: Folder): void {
        this.selectedInstanceObject = folder;
        this.instanceObjectSelected(folder);
        this.showHideModal('folderLookup', false);
      }
    },
  })
</script>
